import React, { Component } from 'react';

import {
  Header,
  LogoContainer,
  PartnerLogo,
  PayPalLogo,
} from './redux/components/styles/cobranded-header';

export default class CobrandedHeader extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Header id='nemo_headerlogo'>
        <LogoContainer>
          <PartnerLogo logo={this.props.cobrandedLogo} />
          <PayPalLogo cdnHost={this.props.cdnHost}>PayPal</PayPalLogo>
        </LogoContainer>
      </Header>
    );
  }
}
